import React from "react";

import Desc from "../Desc/Desc.pc";
import RemoteDetail from "../RemoteDetail/RemoteDetail.pc";
import JobHeader from "../JobHeader/JobHeader.pc";
import Location from "../Location/Location.pc";
import Recruiter from "../Recruiter/Recruiter.pc";

import styles from "./MainSection.pc.module.scss";

export default function MainSection({ dictionary, countryKey, transData, data, sessionid, jobId }) {
  return (
    <>
      <div className={styles.mainSection}>
        <JobHeader
          transData={transData}
          jobId={jobId}
          sessionid={sessionid}
          data={{
            ...data.remote_job_detail,
            ...data.job_header,
            allData: data,
            translationTitle: data.job_translation.translation_content.job_title
          }}
        />
        <RemoteDetail dictionary={dictionary.jobDetail} data={data.remote_job_detail} />
        <Desc
          transData={transData}
          countryKey={countryKey}
          data={{
            ...data.job_description,
            extraInfo: data.japan_info,
            translationSkills: data.job_translation.translation_content.job_skills,
            translationDescription: data.job_translation.translation_content.job_description_html,
            translationRequirements: data.job_translation.translation_content.job_requirements_html,
            benefits_info: data.benefits_info,
            aiTranslate: {
              translateText: data.job_translation.ai_translate_text,
              originalText: data.job_translation.show_original_text,
              translationText: data.job_translation.show_translation_text
            }
          }}
        />
        <Recruiter
          dictionary={dictionary.jobDetail}
          data={data}
          sessionid={sessionid}
          jobId={jobId}
        />
        <Location data={data.working_location} />
        {/* <Benefits data={data.benefits_info} /> */}
        <p className={styles.pubDate}>{data.published_at}</p>
      </div>
    </>
  );
}
